/** Sonderkennzeichen der Assistenzleistung: genau eines je Fall (Prototyp index.html:884-907). */

export const BILLING_CODES = {
  nurErsteinschaetzung: "19816313",
  nurVideosprechstunde: "19816336",
  ersteinschaetzungUndVideo: "19816342",
} as const;
export type BillingCode = (typeof BILLING_CODES)[keyof typeof BILLING_CODES];

export const DEFAULT_FLAT_FEE_CENTS = 3000;

export function billingCodeFor(services: { triage: boolean; video: boolean }): BillingCode | null {
  if (services.triage && services.video) return BILLING_CODES.ersteinschaetzungUndVideo;
  if (services.video) return BILLING_CODES.nurVideosprechstunde;
  if (services.triage) return BILLING_CODES.nurErsteinschaetzung;
  return null;
}
